import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import NoteSvg from '../images/note.svg';
import { ReactComponent as SignInWith1CampusSvg } from '../images/sign-in-with-1campus.svg';
import { ReactComponent as SignInWithGoogleSvg } from '../images/sign-in-with-google.svg';

import * as firebase from 'firebase/app';
import 'firebase/auth';

const Container = styled.section`
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;
const Content = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;
const Logo = styled.object`
  max-width: 20rem;
  width: 100vw;
`;
const Slog = styled.p`
  font-size: calc(1rem + 2vmin);
  color: white;
  margin: 3rem 0;
`;
const Caption = styled.footer`
  font-size: 1rem;
  color: white;
`;
const Version = styled.footer`
  font-size: 0.75rem;
  color: #959595;
`;
const SignInWith1Campus = styled(SignInWith1CampusSvg)`
  margin: 0.5rem;
  cursor: pointer;
`;
const SignInWithGoogle = styled(SignInWithGoogleSvg)`
  margin: 0.5rem;
  cursor: pointer;
`;

const Component = () => {
  const history = useHistory();

  React.useEffect(() => {
    const offAuthStateChanged = firebase.auth().onAuthStateChanged((state) => {
      if (state) {
        return history.replace('/main');
      }

      let shareId = '';
      if (window.location.hash) {
        shareId = window.location.hash.substr(1);
      }
      try {
        const { v } = JSON.parse(
          `{"${decodeURIComponent(
            window.location.search
              .substr(1)
              .replace(/=/g, '":"')
              .replace(/&/g, '","'),
          )}"}`,
        );

        shareId = v;
      } catch {
        /** empty */
      }

      if (shareId) {
        return history.replace('/main');
      }

      history.replace('/');
    });
    return () => offAuthStateChanged();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <Content>
        <Logo type="image/svg+xml" alt="Note" data={NoteSvg}>
          Note
        </Logo>
        <Slog>影片筆記從這裡開始</Slog>
        <SignInWithGoogle
          onClick={() => {
            const provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithRedirect(provider);
          }}
        />
        <SignInWith1Campus
          onClick={() => {
            const params = [
              `client_id=140632d783e5fcc4810c0b08d103ec9b`,
              `response_type=token`,
              `redirect_uri=${window.location.origin}`,
              `scope=${[
                'User.Mail',
                'User.BasicInfo',
                'User.Application',
              ].join()}`,
              `state=1campus.net`,
            ].join('&');

            window.location.replace(
              `https://auth.ischool.com.tw/oauth/authorize.php?${params}`,
            );
          }}
        />
      </Content>
      <Caption style={{ bottom: '1.5rem' }}>
        Powered by ischool inc. &copy;2020
      </Caption>
      <Version>V.20N30M16</Version>
    </Container>
  );
};

export default Component;
